module.exports = __webpack_public_path__ + "static/media/award3.5f29f940.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/award3.png
// module id = 1347
// module chunks = 0